<template>
  <div class="post-classify-container">
    <div class="post-classify-body">
      <div class="content">
        <div class="title">
          <span>岗位分类</span>
        </div>
        <div class="body">
          <div class="operation">
            <el-row :gutter="30">
              <el-col :span="2">
                <div class="keyword-label">
                  <label for="keyword">关键字：</label>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="keyword">
                  <el-input id="keyword" placeholder="请输入岗位分类名称" v-model="keyword" clearable></el-input>
                </div>
              </el-col>
              <el-col class="search-btn" :span="16">
                <el-button @click="search">查询</el-button>
                <el-button @click="resetListData">重置</el-button>
                <el-button type="primary" @click="newCreate">新建</el-button>
              </el-col>
            </el-row>
          </div>
          <div class="table">
            <el-table height="100%" :data="tableData" border>
              <el-table-column
                type="index"
                width="100"
                align="center"
                label="序列"
                :resizable="false"
              ></el-table-column>
                <el-table-column v-for="column in columnData"
                  :prop="column.prop"
                  :key="column.prop"
                  :label="column.label"
                  :resizable="column.resizable"
                  :show-overflow-tooltip="true"
                  :align="column.align"
                  :formatter="formatTime"
                ></el-table-column>
              <el-table-column width="200" align="center" label="操作">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    :disabled="scope.row.name === '默认分类'"
                    @click="deleteColumn(scope.row.id)"
                  >删除</el-button>
                  <el-button
                    type="text"
                    :disabled="scope.row.name === '默认分类'"
                    @click="modifyColunm(scope.row)"
                  >修改</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="paging">
            <el-pagination
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="parseInt(totalNum)"
              :page-sizes="[10, 20, 30, 50, 100]"
              :page-size="pageSize"
              @size-change="sizeChange"
              @current-change="currentChange"
              :current-page="pageNo"
            ></el-pagination>
          </div>
          <div class="dialog">
            <el-dialog
              title="新增岗位分类"
              :visible.sync="dialogVisible"
              :close-on-press-escape="isClossOnPressEscape"
              :close-on-click-modal="false"
              @close="CloseDialog"
            >
              <div class="dialog-body">
                <div class="dialog-content">
                  <el-row :gutter="20">
                    <el-col :span="3.1">
                      <div class="post-name-label">
                        <label for="postName">岗位名称：</label>
                      </div>
                    </el-col>
                    <el-col class="post-name-input" :span="20">
                      <el-input id="postName" placeholder="请输入岗位名称" v-model="postName"></el-input>
                    </el-col>
                  </el-row>
                </div>
                <div class="option-btn">
                  <el-button type="info" @click="cancel">取消</el-button>
                  <el-button type="primary" @click="savePostName">保存</el-button>
                </div>
              </div>
            </el-dialog>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const columnData = [
  {
    prop: 'id',
    label: '岗位分类ID',
    resizable: false,
    align: 'center'
  },
  {
    prop: 'name',
    label: '岗位分类名称',
    resizable: false,
    align: 'center'
  },
  {
    prop: 'createTime',
    label: '创建时间',
    resizable: false,
    align: 'center'
  }
]
export default {
  name: 'postClassify',
  data () {
    return {
      keyword: '',
      tableData: [],
      columnData,
      dialogVisible: false,
      totalNum: 0,
      // 是否通过esc关闭
      isClossOnPressEscape: true,
      // 岗位名称
      postName: '',
      pageNo: 1,
      pageSize: 20,
      // 需要修改的数据的id
      modifyId: ''
    }
  },
  created () {
    this.$nextTick(res => {
      this.getListData()
    })
  },
  methods: {
    // 新建
    newCreate () {
      this.dialogVisible = true
    },
    // 关闭的时候调用
    CloseDialog () {
      this.modifyId = ''
      this.postName = ''
    },
    // 保存
    savePostName () {
      let _self = this
      if (
        _self.postName.replace(/(^\s*)|(\s*$)/g, '') !== '' &&
        _self.postName.replace(/(^\s*)|(\s*$)/g, '').length <= 20
      ) {
        // 是保存数据
        if (_self.modifyId === '') {
          let data = {
            name: _self.postName
          }
          _self.$axios
            .post('/auth-api/postCategory', data)
            .then(res => {
              if (res.data.code !== 400) {
                _self.$message({
                  type: 'success',
                  message: '保存成功！'
                })
                _self.modifyId = ''
                _self.postName = ''
                _self.dialogVisible = false
                _self.getListData()
              } else {
                _self.$message.error(res.data.msg)
              }
            })
            .catch(() => { _self.getListData() })
        } else {
          // 修改数据
          let data = {
            id: _self.modifyId,
            name: _self.postName
          }
          _self.$axios
            .post('/auth-api/postCategory', data)
            .then(res => {
              if (res.data.code === 400) {
                _self.$message.error(res.data.msg)
              } else {
                this.$message({
                  type: 'success',
                  message: '修改成功！'
                })
                _self.modifyId = ''
                _self.postName = ''
                _self.dialogVisible = false
                _self.getListData()
                this.getListData()
              }
            })
        }
      } else if (_self.postName.replace(/(^\s*)|(\s*$)/g, '') === '') {
        _self.$message.error('岗位名称不能为空！')
      } else if (_self.postName.replace(/(^\s*)|(\s*$)/g, '').length > 20) {
        _self.$message.error('岗位名称长度不能超过20！')
      }
    },
    // 取消
    cancel () {
      this.dialogVisible = false
      this.modifyId = ''
      this.postName = ''
    },
    // 获取列表数据
    getListData () {
      this.$nextTick(() => {
        let params = {
          index: this.pageNo,
          size: this.pageSize,
          filters: {
            name: this.keyword
          }
        }
        this.$axios
          .get(`/auth-api/postCategory`, {params})
          .then(res => {
            this.tableData = res.data.items
            this.totalNum = parseInt(res.data.total)
          })
      })
    },
    // 重置
    resetListData () {
      this.pageNo = 1
      this.keyword = ''
      this.pageSize = 20
      this.$nextTick(() => {
        this.getListData()
      })
    },
    // 删除
    deleteColumn (id) {
      this.$confirm('是否确认删除？', '', {
        confirmButtonText: '是的，我确认删除',
        cancelButtonText: '容我重新思考一下',
        customClass: 'deleMessageBox-custom'
      })
        .then(() => {
          this.$axios
            .delete(`/auth-api/postCategory/${id}`)
            .then(res => {
              this.$message({
                type: 'success',
                message: '删除成功！'
              })
              this.getListData()
            })
        })
        .catch(() => {})
    },
    // 修改
    modifyColunm (row) {
      this.postName = row.name
      this.modifyId = row.id
      this.$nextTick(() => {
        this.dialogVisible = true
      })
    },
    // 翻页
    currentChange (val) {
      this.pageNo = val
      this.$nextTick(res => {
        this.getListData()
      })
    },
    // 修改一页条数
    sizeChange (val) {
      this.pageNo = 1
      this.pageSize = val
      this.$nextTick(res => {
        this.getListData()
      })
    },
    search () {
      if (this.keyword.replace(/(^\s*)|(\s*$)/g, '') !== '') this.pageNo = 1
      this.keyword = this.keyword.replace(/(^\s*)|(\s*$)/g, '')
      this.$nextTick(() => {
        this.getListData()
      })
    },
    formatTime (row, column, cellValue) {
      if (column.property === 'createTime') {
        if (cellValue) {
          let datetime = new Date(cellValue)
          let y = datetime.getFullYear()
          let m = datetime.getMonth() + 1
          let d = datetime.getDate()
          return `${y}-${m < 10 ? ('0' + m) : m}-${d < 10 ? ('0' + d) : d}`
        }
        return ''
      }
      return cellValue
    }
  }
}
</script>

<style lang="scss">
  .post-classify-container {
      padding: 10px;
      height: 100%;

      div, span, p, label {
        font-size: 12px;
      }

    .post-classify-body {
      background: #fff;
      box-shadow: 0px 3px 9px 0px rgba(179, 196, 208, 0.2);
      border-radius: 4px 0;
      height: 100%;

      .search-btn {
        .el-button--default {
          border-color: var(--primary, #54abf1);
          color: var(--primary, #54abf1);
        }
      }

      .content {
        height: 100%;

        .title {
          padding: 20px 0 10px 50px;
          border-bottom: 1px solid #ccc;

          span {
            font-size: 14px;
          }
        }

        .body {
          padding: 20px;
          height: calc(100% - 54px);
          position: relative;

          .operation {
            padding: 0 0 15px 0;

            @media screen and (min-width: 1400px) {
              .keyword {
                text-align: left;
                margin-left: -20%;
                width: 60%;
              }
            }
            @media screen and (max-width: 1400px) {
              .keyword {
                margin-left: -16%;
                width: 80%;
              }
            }

            .keyword-label {
              height: 32px;
              line-height: 30px;

              label {
                font-size: 12px;
              }
            }

            .search-btn {
              text-align: right;
            }
          }

          .table {
            height: calc(100% - 85px);
            overflow: auto;
          }

          .paging {
            text-align: right;
            padding: 15px 0;
          }

          .dialog {
            .dialog-body {
              .dialog-content {
                height: 50px;

                .post-name-label {
                  height: 32px;
                  line-height: 32px;
                }

                .post-name-input {
                  margin-left: -16px;
                }
              }

              .option-btn {
                text-align: center;

                button {
                  margin: 0 10px;
                }
              }
            }
          }
        }
      }
    }
  }

  @import "@/assets/scss/common.scss";
</style>



// WEBPACK FOOTER //
// src/components/system/users/post-classify.vue